module.exports = __webpack_public_path__ + "static/img/dropoff-banner1.a7eead42.jpeg";